import * as React from 'react';
import styled from 'styled-components';
import Text11 from '@sdk/components/ui/typography/Text11';
import gettext from '@sdk/lang/gettext';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';

import AddIcon from '../../assets/svg/UI/add-small.svg';

export const ADD_EMPLOYEE_ROW_HEIGHT = 40;

const LinkContainer = styled.a`
  height: ${ADD_EMPLOYEE_ROW_HEIGHT}px;
  align-items: center;
  opacity: 0.65;
  display: flex;

  &:hover,
  &:focus,
  &:active {
    outline: 0;
    opacity: 1;
    text-decoration: none;
  }
`;

const AddEmployeeText = styled(Text11)`
  margin-left: 10px;
  text-transform: uppercase;
`;

type Props = {
  addUser: () => void;
};

const AddEmployeeRow: React.FC<React.PropsWithChildren<Props>> = ({ addUser }) => {
  return (
    <LinkContainer onClick={addUser}>
      <AddIcon />
      <AddEmployeeText bold themeColor={ThemeColorType.gray}>
        {gettext('Add employee')}
      </AddEmployeeText>
    </LinkContainer>
  );
};

export default AddEmployeeRow;
